module.exports = __webpack_public_path__ + "img/rifeng.ab6eb0e7.jpg";